export const appBuildAssetsDir = "/appassets"

export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1"},{"charset":"utf-8"}],"link":[],"style":[{"innerHTML":"@font-face{font-family:'Lato';font-display:optional;src:local('Lato Regular'),local('Lato-Regular'), url('/appassets/fonts/lato-regular.woff2') format('woff2'),url('/appassets/fonts/lato-regular.woff') format('woff');font-weight: normal;font-style: normal;}\n@font-face{font-family:'Lato';font-display:optional;src:local('Lato Bold'),local('Lato-Bold'), url('/appassets/fonts/lato-700.woff2') format('woff2'),url('/appassets/fonts/lato-700.woff') format('woff');font-weight: bold;font-style: normal;}\n@font-face{font-family:'Lato';font-display:optional;src:local('Lato Black'),local('Lato-Black'), url('/appassets/fonts/lato-900.woff2') format('woff2'),url('/appassets/fonts/lato-900.woff') format('woff');font-weight: 900;font-style: normal;}\n@font-face{font-family:'Anton';font-display:optional;src:local('Anton Regular'),local('Anton-Regular'),url('/appassets/fonts/anton-regular.woff2') format('woff2'),url('/appassets/fonts/anton-regular.woff') format('woff');font-weight: normal;font-style: normal;ascent-override: 120%;}\n@font-face{font-family:'Lato-fallback';src:local(Arial);advance-override: 275.1%;// ascent-override: 197.4%;descent-override: -426%;line-gap-override: 0;}\n@font-face{font-family:'Anton-fallback';src:local(Impact);ascent-override: 90%;size-adjust: 95%;}","tagPriority":"critical"}],"script":[],"noscript":[]}

export const appBaseURL = "/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = {"enabled":false}

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = false

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"deep":false}

export const useStateDefaults = {"resetOnClear":false}

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = true

export const purgeCachedData = true

export const granularCachedData = true

export const pendingWhenIdle = false

export const alwaysRunFetchOnKeyChange = false

export const asyncCallHook = true